module.exports = __webpack_public_path__ + "f26b8fdd0ac0293bb61be923304df117.png";